module.exports = __webpack_public_path__ + "img/increase-decrease-fill.032c4cc4.svg";